import React from 'react';
import {Link} from 'react-router-dom';
import {ID} from '@datorama/akita';
import {LeagueEvent} from '../domain/leagueevent/models';
import './LeagueEventTiles.css';

interface Props {
    leagueId: ID;
    events: LeagueEvent[];
    usePublicLink?: boolean;
}

function formatEventDate(dateString: string, fallback: Date): string {
    const raw = dateString || (fallback ? fallback.toString() : '');
    if (!raw) return '';
    const d = new Date(raw.length === 10 ? raw + 'T12:00:00' : raw);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US', {year: 'numeric', month: 'short', day: 'numeric'});
}

export function LeagueEventTiles({leagueId, events, usePublicLink}: Props) {
    if (events.length === 0) return null;
    return (
        <div className="league-event-tiles">
            {events.map(e => (
                <Link
                    key={e.id}
                    to={usePublicLink ? `/league/${leagueId}/events/${e.id}` : `/league/${leagueId}/manage/events/${e.id}`}
                    className="league-event-tile">
                    <div className="league-event-tile-date">{formatEventDate(e.dateString, e.date)}</div>
                    <div className="league-event-tile-name">{e.name || 'League event'}</div>
                </Link>
            ))}
        </div>
    );
}
